import React, {useEffect, useState} from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import Skills from "./skills/Skills";
// import StackProgress from "./skillProgress/skillProgress";
import WorkExperience from "./workExperience/WorkExperience";
import StartupProject from "./StartupProjects/StartupProject";
import Achievement from "./achievement/Achievement";
import Blogs from "./blogs/Blogs";
import Footer from "../components/footer/Footer";
import Education from "./education/Education";
import ScrollToTopButton from "./topbutton/Top";
import Profile from "./profile/Profile";
import SplashScreen from "./splashScreen/SplashScreen";
import {splashScreen} from "../portfolio";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";
// import Projects from "./projects/Projects";
import "./Main.scss";
import Testimony from "./testimony/Testimony";
import { Helmet } from "react-helmet-async";
import EnterpriseProjects from "./EnterpriseProjects/EnterpriseProjects";
const Main = () => {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode" : null}>
      <Helmet>
  <title>
    Anil Gulati | Full Stack & AI Engineer | Scalable Systems & Backend
  </title>

  <meta
    name="description"
    content="Anil Gulati is a Full Stack & AI Engineer based in Paris, building scalable backend systems, distributed architectures, and AI-driven applications using Java, Node.js, and modern data pipelines."
  />

  <meta
    name="keywords"
    content="Anil Gulati, AI Engineer, Backend Engineer, Full Stack Developer, Java Spring Boot, Node.js, Distributed Systems, Machine Learning, Data Engineering, AWS, Scalable Systems"
  />

  <link rel="canonical" href="https://anilgulati.com/" />

  {/* Open Graph (LinkedIn / WhatsApp / Facebook) */}
  <meta property="og:title" content="Anil Gulati | Full Stack & AI Engineer" />
  <meta
    property="og:description"
    content="Building scalable backend systems and AI-driven applications across enterprise and real-world platforms."
  />
  <meta property="og:url" content="https://anilgulati.com/" />
  <meta property="og:type" content="website" />

  {/* Twitter Preview */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Anil Gulati | Full Stack & AI Engineer"
  />
  <meta
    name="twitter:description"
    content="Scalable backend systems, AI pipelines, and production-grade platforms."
  />

  {/* Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
      "@id": "https://anilgulati.com/#person",
      name: "Anil Gulati",
      url: "https://anilgulati.com/",
      jobTitle: "Full Stack & AI Engineer",
      description:
        "Engineer building scalable backend systems, distributed architectures, and AI-powered applications across enterprise and real-world platforms.",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Paris",
        addressCountry: "France"
      },
      email: "hi@anilgulati.com",
      sameAs: [
        "https://github.com/anilfromdit",
        "https://www.linkedin.com/in/anilfromdit/",
        "https://medium.com/@anilfromdit"
      ],
      knowsAbout: [
        "Java",
        "Spring Boot",
        "Node.js",
        "Backend Engineering",
        "Distributed Systems",
        "Microservices",
        "APIs",
        "SQL",
        "MongoDB",
        "AWS",
        "Docker",
        "Python",
        "Machine Learning",
        "Artificial Intelligence",
        "LLMs",
        "Data Engineering",
        "Kafka",
        "System Design"
      ],
      hasCredential: [
        {
          "@type": "EducationalOccupationalCredential",
          name: "Oracle Certified Associate, Java SE 8 Programmer"
        }
      ]
    })}
  </script>
</Helmet>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : (
          <>
            <Header />
            <Greeting />
            <Skills />
            <Education />
            <Testimony/>
            <WorkExperience />
            <EnterpriseProjects />
            <StartupProject />
            {/* <Projects/> */}
            
            <Achievement />
            <Blogs />
            <Profile />
            <Footer />
            <ScrollToTopButton />
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default Main;
